import styles from "./AmbientToggle.module.css"
import { useState} from "react"

const AmbientToggle = () => {
    const [ isAmbient, setIsAmbient] = useState(false)
  return (
      <div className={styles.ambient_toggle_container}>
          <button className={ isAmbient ? styles.active_btn : styles.non_active_btn} onClick={() => setIsAmbient(!isAmbient)}>Ambient Liquidity</button>
          <button className={isAmbient ? styles.non_active_btn : styles.active_btn} onClick={() => setIsAmbient(!isAmbient)}>Concentrated Liquidity</button>
      
      </div>
  )
}

export default AmbientToggle